import { isNil } from 'ramda';
import { isWithinInterval, parseISO } from 'date-fns';
import { PlanUnit } from '../../types';

const includeParentUnits = (data, filteredData) => {
  const filteredIds = new Set(filteredData.map((item) => item.brId));

  const newFilteredData = data.reduce(
    (acc, item) => {
      if (filteredIds.has(item.brId)) {
        item.hierarchy.forEach((parentId) => {
          const parentItem = data.find(
            (parent) => parent.brId.toString() === parentId
          );
          if (parentItem && !filteredIds.has(parentItem.brId)) {
            filteredIds.add(parentItem.brId);
            acc.push(parentItem);
          }
        });
      }
      return acc;
    },
    [...filteredData]
  );

  return newFilteredData;
};

export const filterByReferenceDate = (
  data: PlanUnit[],
  referenceDate: string | number | Date | null
) => {
  if (isNil(referenceDate)) return data;

  const filteredData = data.filter((item) => {
    return (
      item.valid &&
      item.valid.from &&
      item.valid.to &&
      isWithinInterval(new Date(referenceDate), {
        start: parseISO(item.valid.from),
        end: parseISO(item.valid.to)
      })
    );
  });

  return includeParentUnits(data, filteredData);
};

export const filterPoolId = (data, poolId, noPool) => {
  if (isNil(poolId) && !noPool) return data;

  const filteredData = noPool
    ? data.filter((item) => !item.pool)
    : isNil(poolId)
    ? data
    : data.filter((item) => item.pool && item.pool.id === poolId);

  return includeParentUnits(data, filteredData);
};

export const filterEmployerId = (data, employerId, noEmployer) => {
  const filteredData = noEmployer
    ? data.filter((item) => !item.employerId)
    : isNil(employerId)
    ? data
    : data.filter((item) => item.employerId === employerId);

  return includeParentUnits(data, filteredData);
};

export const filterBySearch = (data, search) => {
  if (isNil(search)) return data;

  const filteredData = data.filter(
    (item) =>
      item.name?.toLowerCase().includes(search.toLowerCase()) ||
      item.code?.toLowerCase().includes(search.toLowerCase())
  );

  return includeParentUnits(data, filteredData);
};

export const filterByEmpPoolId = (data, empPoolId, noEmployeePool) => {
  if (isNil(empPoolId) && !noEmployeePool) return data;

  const filteredData = noEmployeePool
    ? data.filter((item) => !item.empPool)
    : isNil(empPoolId)
    ? data
    : data.filter((item) => item.empPool && item.empPool.id === empPoolId);

  return includeParentUnits(data, filteredData);
};

export const filterByClusterId = (
  data: PlanUnit[],
  clusterId: number | null
) => {
  if (isNil(clusterId)) return data;

  const filteredData = data.filter((item) =>
    item.clusters.some((cluster) => cluster.clusterId === clusterId)
  );

  return includeParentUnits(data, filteredData);
};
